var map = {
	"./2.JPG": 9638,
	"./Annual Conference at Delhi.JPG": 8744,
	"./Case Studies by Experts.JPG": 2637,
	"./Growing Together.JPG": 837,
	"./Insights from Industry Experts.JPG": 5512,
	"./Learning by Doing.JPG": 8308,
	"./Networking with Peers.JPG": 601,
	"./Reward & Recogntion.JPG": 1585,
	"./_F3A8539.JPG": 9896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4238;